var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllOfUsLogoFooter({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 132 41",
    style: {
      enableBackground: "new 0 0 132 41"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{enable-background:new    ;}\n\t.st1{fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Footer-v2",
    transform: "translate(-21.000000, -25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(21.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5,40l-1.4-2H2.5v2H1.1v-6.4H4c1.5,0,2.4,0.8,2.4,2.1v0c0,1-0.6,1.7-1.4,2L6.6,40H5z M5,35.8 c0-0.6-0.4-0.9-1.1-0.9H2.5v1.8h1.4C4.6,36.7,5,36.4,5,35.8L5,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.7,40v-6.4h4.8v1.2H9.1v1.3h3v1.2h-3v1.3h3.5V40H7.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.1,40.1c-1,0-1.9-0.3-2.7-1l0.8-1c0.6,0.5,1.2,0.8,1.9,0.8c0.6,0,0.9-0.2,0.9-0.6v0 c0-0.4-0.2-0.5-1.3-0.8c-1.3-0.3-2.1-0.7-2.1-1.9v0c0-1.2,0.9-1.9,2.2-1.9c0.9,0,1.7,0.3,2.4,0.8l-0.7,1.1 c-0.6-0.4-1.1-0.6-1.7-0.6S15,35,15,35.3v0c0,0.4,0.3,0.6,1.4,0.8c1.3,0.3,2,0.8,2,1.9v0C18.4,39.4,17.4,40.1,16.1,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.6,40v-6.4h4.8v1.2H21v1.3h3v1.2h-3v1.3h3.5V40H19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M30.5,40l-0.6-1.4h-2.7L26.6,40h-1.4l2.7-6.4h1.3l2.7,6.4H30.5z M28.5,35.3l-0.8,2.1h1.7L28.5,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.8,40l-1.4-2h-1.1v2h-1.4v-6.4h2.9c1.5,0,2.4,0.8,2.4,2.1v0c0,1-0.6,1.7-1.4,2l1.6,2.3H36.8z M36.8,35.8 c0-0.6-0.4-0.9-1.1-0.9h-1.4v1.8h1.4C36.4,36.7,36.8,36.4,36.8,35.8L36.8,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.5,40.1c-1.9,0-3.3-1.4-3.3-3.3v0c0-1.8,1.4-3.3,3.3-3.3c1.2,0,1.9,0.4,2.5,1l-0.9,1 c-0.5-0.4-1-0.7-1.6-0.7c-1.1,0-1.8,0.9-1.8,2v0c0,1.1,0.8,2,1.8,2c0.7,0,1.2-0.3,1.7-0.7l0.9,0.9 C44.4,39.7,43.7,40.1,42.5,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.2,40v-2.6h-2.6V40h-1.4v-6.4h1.4v2.5h2.6v-2.5h1.4V40H50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.1,40v-6.4h4.8v1.2h-3.4v1.3h3v1.2h-3v1.3H58V40H53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63.1,40l-1.4-2h-1.1v2h-1.4v-6.4h2.9c1.5,0,2.4,0.8,2.4,2.1v0c0,1-0.6,1.7-1.4,2l1.6,2.3H63.1z M63.1,35.8 c0-0.6-0.4-0.9-1.1-0.9h-1.4v1.8H62C62.7,36.7,63.1,36.4,63.1,35.8L63.1,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.5,40h-1.2l-1.4-4.2L71.4,40h-1.2L68,33.6h1.5l1.3,4.3l1.4-4.3h1.2l1.4,4.3l1.3-4.3h1.5L75.5,40z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.5,40.1c-2,0-3.4-1.5-3.4-3.3v0c0-1.8,1.4-3.3,3.4-3.3c2,0,3.4,1.5,3.4,3.3v0 C84.8,38.6,83.4,40.1,81.5,40.1z M83.4,36.8c0-1.1-0.8-2-1.9-2c-1.1,0-1.9,0.9-1.9,2v0c0,1.1,0.8,2,1.9,2 C82.6,38.8,83.4,37.9,83.4,36.8L83.4,36.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90,40l-1.4-2h-1.1v2h-1.4v-6.4H89c1.5,0,2.4,0.8,2.4,2.1v0c0,1-0.6,1.7-1.4,2l1.6,2.3H90z M90,35.8 c0-0.6-0.4-0.9-1.1-0.9h-1.4v1.8h1.4C89.6,36.7,90,36.4,90,35.8L90,35.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.8,40l-2-2.7l-0.7,0.8V40h-1.4v-6.4h1.4v2.8l2.6-2.8h1.7l-2.6,2.7l2.7,3.7H96.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M102.4,40h-3v-6.4h3c1.3,0,2.1,0.6,2.1,1.6v0c0,0.7-0.4,1.1-0.8,1.4c0.7,0.3,1.2,0.7,1.2,1.6v0 C104.7,39.4,103.8,40,102.4,40z M103,35.5c0-0.4-0.3-0.7-0.9-0.7h-1.4v1.3h1.3C102.6,36.2,103,36,103,35.5L103,35.5z  M103.3,38.1c0-0.4-0.3-0.7-1-0.7h-1.6v1.4h1.7C103,38.8,103.3,38.6,103.3,38.1L103.3,38.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.9,40v-6.4h4.8v1.2h-3.4v1.3h3v1.2h-3v1.3h3.5V40H105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.5,40l-3.1-4v4H112v-6.4h1.3l3,3.9v-3.9h1.4V40H116.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.2,40.1c-1.9,0-3.3-1.4-3.3-3.3v0c0-1.8,1.4-3.3,3.3-3.3c1.2,0,1.9,0.4,2.5,1l-0.9,1 c-0.5-0.4-1-0.7-1.6-0.7c-1.1,0-1.8,0.9-1.8,2v0c0,1.1,0.8,2,1.8,2c0.7,0,1.2-0.3,1.7-0.7l0.9,0.9 C124.1,39.7,123.4,40.1,122.2,40.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.9,40v-2.6h-2.6V40h-1.4v-6.4h1.4v2.5h2.6v-2.5h1.4V40H129.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "All_Of_Us_Logo",
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.662325, 6.222222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st1",
    d: "M0.2,12.2c0-0.8,0.2-1.7,0.7-2.6c0.5-0.9,1.2-1.7,2.2-2.3s2.2-0.9,3.6-0.9 c1.7,0,3,0.4,3.8,1.2c0.8,0.8,1.2,1.8,1.2,3c0,1.6-0.6,3-1.9,4.2s-2.8,1.8-4.8,1.8c-1.4,0-2.6-0.3-3.5-1.1 C0.7,14.7,0.2,13.7,0.2,12.2 M3.6,13.3c0,0.7,0.1,1.2,0.4,1.5c0.2,0.3,0.7,0.5,1.2,0.5c1,0,1.7-0.7,2.3-2.1 c0.6-1.4,0.9-2.6,0.9-3.6c0-0.7-0.2-1.3-0.4-1.6c-0.3-0.3-0.6-0.5-1-0.5c-1,0-1.8,0.7-2.4,2.2C3.9,11.2,3.6,12.4,3.6,13.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "st1",
    d: "M17.9,8l-1.2,5.2c-0.7,3-1.6,5.2-2.7,6.7c-1.1,1.5-2.6,2.2-4.5,2.2c-0.9,0-1.6-0.2-2-0.5 c-0.4-0.3-0.6-0.8-0.6-1.2c0-0.4,0.2-0.8,0.5-1.1c0.3-0.3,0.7-0.5,1.1-0.5c0.9,0,1.4,0.5,1.6,1.4c0.1,0.5,0.3,0.7,0.6,0.7 c0.4,0,0.7-0.3,1-1c0.3-0.7,0.7-1.9,1.1-3.9l0.3-1.7c0.1-0.4,0.2-0.7,0.2-0.9L14.5,8H13l0.4-1.3h1.4c0.7-2.6,1.6-4.4,2.5-5.2 c1-0.8,2.1-1.3,3.5-1.3c0.9,0,1.6,0.2,2.2,0.5s0.8,0.8,0.8,1.4c0,0.4-0.1,0.7-0.4,1c-0.3,0.3-0.6,0.4-1,0.4 c-0.6,0-1.1-0.4-1.6-1.3c-0.3-0.6-0.7-1-1-1c-0.4,0-0.7,0.5-0.9,1.5l-0.7,3.9H20L19.6,8L17.9,8L17.9,8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st1",
    d: "M11.5,1h9L32,28.4h-9.9l-1.4-3.7h-9.6l-1.4,3.7H0L11.5,1z M18.4,18.3l-2.5-6.6l-2.5,6.6 H18.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 33.2,
    y: 0,
    className: "st1",
    width: 8.8,
    height: 28.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1_",
    x: 46,
    y: 0,
    className: "st1",
    width: 8.8,
    height: 28.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1_",
    transform: "translate(81.880173, 0.933333)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.2,15.3v-15h9.3v14.9c0,3.4,1.7,4.8,4.2,4.8s4.2-1.3,4.2-4.6V0.3h9.3v14.8c0,9.3-5.4,12.9-13.5,12.9 C5.4,28.1,0.2,24.3,0.2,15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28.3,24.9l3-5c2.6,1.6,5.4,2.4,7.9,2.4c0.9,0,1.3-0.2,1.3-0.7v-0.1c0-0.4-0.4-0.7-2.5-1.2 c-5.4-1.3-8.7-2.8-8.7-7.2V13c0-4.7,3.7-7.3,9.3-7.3c3.5,0,7,0.9,9.5,2.5l-2.8,5.3c-2.3-1.2-5-2-6.8-2 c-0.9,0-1.2,0.2-1.2,0.7v0.1c0,0.4,0.5,0.7,2.6,1.2c5.4,1.3,8.6,2.8,8.6,7.2v0.1c0,4.6-3.5,7.3-9.2,7.3 C35,28,31.3,26.9,28.3,24.9"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllOfUsLogoFooter);
export default __webpack_public_path__ + "static/media/all-of-us-logo-footer.439f0ae419f92a85dac590ddafb96de2.svg";
export { ForwardRef as ReactComponent };